import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    selectRootContainer: {
        position: 'relative',
    },
    parentContainer: {
        position: 'relative',
        width: 'auto',
        height: 'auto',
        display: 'flex',
        flex_direction: 'row',
        column_gap: FOUNDATIONS.spacing_150,
        background_color: FOUNDATIONS.color_comp_forms_select_bg,
        border_radius: FOUNDATIONS.radius_1000,
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
        align_items: 'center',
        cursor: 'pointer',
        ...STATE_TOKENS.parentContainer,
    },
    rightIconContainer: {
        display: 'flex',
        ...STATE_TOKENS.rightIconContainer,
    },
    leftIconContainer: {
        display: 'flex',
        align_self: 'flex-start',
        ...STATE_TOKENS.leftIconContainer,
    },
    leftIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_comp_forms_select_icon,
        ...STATE_TOKENS.leftIcon,
    },
    icon: {
        width: FOUNDATIONS.size_125,
        height: FOUNDATIONS.size_75,
        color: FOUNDATIONS.color_comp_forms_select_icon,
        ...STATE_TOKENS.icon,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_select_default_font,
        ...STATE_TOKENS.label,
    },
    illustration: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        ...STATE_TOKENS.illustration,
    },
    illustrationContainer: {
        display: 'flex',
        align_self: 'flex-start',
        ...STATE_TOKENS.illustrationContainer,
    },
    optionListWrapper: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
    },
    buttonMenuGap: FOUNDATIONS.spacing_200,
});
//# sourceMappingURL=commonStyles.js.map